import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'sd-personal-data-agree-text-callback',
  templateUrl: './personal-data-agree-text-callback.component.html',
  styleUrls: ['./personal-data-agree-text-callback.component.scss'],
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalDataAgreeTextCallbackComponent {}
